(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["excel-cart-popup"]) return;
  try {
    
  if (!customElements.get('excel-cart-popup')) {
    customElements.define('excel-cart-popup', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.dialog = this.querySelector('dialog');
        this.panel = this.querySelector('.ecp-panel');
        this.heading = this.querySelector('#ExcelCartTitle');
        this.queue = Promise.resolve();
        this.pendingForms = new WeakSet();
        this.pending = 0;
        this.productStock = new WeakMap();
        this.stock = JSON.parse(this.querySelector('[data-cart-stock]').textContent);
        const options = {signal:this.controller.signal};
        document.addEventListener('click', event => this.onDocumentClick(event), {...options, capture:true});
        document.addEventListener('submit', event => this.onSubmit(event), {...options, capture:true});
        document.addEventListener('input', event => this.onStockInput(event), {...options, capture:true});
        document.addEventListener('change', event => this.onStockInput(event), {...options, capture:true});
        document.addEventListener('focusout', event => {
          if (event.target.matches('excel-product-card input[name="quantity"], excel-product-detail input[name="quantity"]')) this.onStockInput(event);
        }, options);
        document.addEventListener('keyup', event => {
          if (event.target.matches('[data-cartitem] [data-quantity-input]')) event.stopImmediatePropagation();
        }, {...options, capture:true});
        document.addEventListener('keydown', event => {
          if (event.key === 'Enter' && event.target.matches('[data-cartitem] [data-quantity-input]')) {
            event.preventDefault(); event.stopImmediatePropagation(); this.commitPageQuantity(event.target);
          }
        }, {...options, capture:true});
        this.addEventListener('click', event => this.onClick(event), options);
        this.addEventListener('change', event => this.onQuantityChange(event), options);
        this.dialog.addEventListener('keydown', event => this.onKeydown(event), options);
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, options);
        this.dialog.addEventListener('close', () => { if (!this.dialog.open) this.afterClose(); }, options);
        this.dialog.addEventListener('pointerdown', event => { this.backdropDown = event.target === this.dialog; }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target === this.dialog && this.backdropDown) this.close();
          this.backdropDown = false;
        }, options);
        const handle = this.querySelector('.ecp-handle');
        handle.addEventListener('pointerdown', event => { this.dragStart = event.clientY; handle.setPointerCapture(event.pointerId); }, options);
        handle.addEventListener('pointerup', event => { if (event.clientY - this.dragStart > 45) this.close(); this.dragStart = null; }, options);
        handle.addEventListener('pointercancel', () => { this.dragStart = null; }, options);
        const toast = this.querySelector('[data-cart-toast]');
        toast.addEventListener('pointerenter', () => clearTimeout(this.toastTimer), options);
        toast.addEventListener('pointerleave', () => this.scheduleToastHide(1200), options);
        window.addEventListener('pageshow', () => { if (this.dialog.open) this.open(); }, options);
        window.addEventListener('pagehide', () => this.close(false), options);
        document.addEventListener('shopify:section:load', () => this.decorateTriggers(), options);
        window.addEventListener('focus', () => this.refreshProducts(), options);
        window.addEventListener('pageshow', event => {
          this.syncProducts();
          if (event.persisted) this.refreshProducts();
        }, options);
        this.observer = new MutationObserver(records => {
          if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-stock-product], [data-stock-variant]') || node.querySelector('[data-stock-product], [data-stock-variant]'))))) this.syncProducts();
        });
        this.observer.observe(document.body, {childList:true, subtree:true});
        this.decorateTriggers();
        this.syncProducts();
        this.syncCartLimits();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        clearTimeout(this.toastTimer);
        cancelAnimationFrame(this.toastFrame);
        if (this.dialog?.open) this.close(false);
      }

      decorateTriggers() {
        document.querySelectorAll('.site-header-cart--button').forEach(trigger => {
          trigger.setAttribute('aria-haspopup', 'dialog');
          trigger.setAttribute('aria-controls', 'ExcelCartPopup');
        });
      }

      onDocumentClick(event) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const cartControl = event.target.closest('[data-cartitem] [data-quantity-plus], [data-cartitem] [data-quantity-minus], [data-cartitem-remove]');
        if (cartControl) {
          event.preventDefault(); event.stopImmediatePropagation();
          if (cartControl.disabled || this.pending) return;
          const row = cartControl.closest('[data-cartitem]');
          const input = row.querySelector('[data-quantity-input]');
          if (cartControl.hasAttribute('data-quantity-plus') && this.atLimit(input)) {
            this.stockFeedback(input.closest('[data-quantity-selector]'), cartControl.dataset.limitLabel, event.detail === 0);
            return;
          }
          const quantity = cartControl.hasAttribute('data-cartitem-remove') ? 0 : this.steppedQuantity(input, cartControl.hasAttribute('data-quantity-plus') ? 1 : -1);
          this.change(row.dataset.cartitemKey, quantity, cartControl, true);
          return;
        }
        const productStep = event.target.closest('[data-quantity-plus], [data-quantity-minus]');
        if (productStep) {
          const input = productStep.closest('[data-quantity-selector]')?.querySelector('input');
          if (input?.form?.querySelector('[data-stock-product]')) {
            event.preventDefault(); event.stopImmediatePropagation();
            const atLimit = productStep.hasAttribute('data-quantity-plus') && (input.disabled || input.max !== '' && Number(input.value) + Number(input.step || 1) > Number(input.max));
            if (atLimit) {
              this.stockFeedback(input.closest('[data-quantity-selector]'), productStep.dataset.limitLabel, event.detail === 0);
              return;
            }
            if (!productStep.disabled && !input.disabled) {
              input.value = this.steppedQuantity(input, productStep.hasAttribute('data-quantity-plus') ? 1 : -1);
              input.dispatchEvent(new Event('change', {bubbles:true}));
            }
            return;
          }
        }
        const trigger = event.target.closest('.site-header-cart--button, [data-cart-popup-open]');
        if (trigger) {
          event.preventDefault();
          event.stopImmediatePropagation();
          // The toast hides as the cart opens, so focus returns to the header cart instead.
          const fromToast = trigger.hasAttribute('data-cart-toast-open');
          this.open(fromToast ? this.cartAnchor() || trigger : trigger, event.detail === 0);
          return;
        }
        const quickBuy = event.target.closest('[data-quick-buy][data-variant-id]');
        if (!quickBuy || quickBuy.disabled) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const data = new FormData();
        data.set('id', quickBuy.dataset.variantId);
        data.set('quantity', String(Number(quickBuy.dataset.stockMinimum) || 1));
        this.add(data, quickBuy);
      }

      onSubmit(event) {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        const url = new URL(form.action, location.href);
        if (form.querySelector('[data-cartitem]') && (this.pending || this.invalidCart || this.cartDirty || this.wireHold())) {
          event.preventDefault(); event.stopImmediatePropagation();
          form.querySelector('[data-line-stock-message]:not([hidden]), [data-wire-hold-note]:not([hidden])')?.scrollIntoView({block:'center'});
          return;
        }
        if (url.origin !== location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(url.pathname)) return;
        if (event.submitter?.name === 'checkout') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.pendingForms.has(form)) return;
        const marker = form.querySelector('[data-stock-product]');
        if (marker && form.closest('excel-product-card, excel-product-detail')) {
          const variant = this.productStock.get(marker);
          const input = form.elements.namedItem('quantity');
          const error = variant && this.quantityError(variant, Number(input?.value));
          if (error) {
            this.normalizeProductQuantity(input);
            this.stockFeedback(event.submitter || form.querySelector('[type="submit"]'), error);
            return;
          }
        }
        if (!form.reportValidity()) return;
        this.pendingForms.add(form);
        const data = new FormData(form);
        const button = event.submitter || form.querySelector('[type="submit"]');
        // A form can ask for several cart lines (spliced wire cuts); the form's own id and quantity still drive the stock check.
        let lines = null;
        try { lines = form.dataset.cartLines ? JSON.parse(form.dataset.cartLines) : null; } catch { lines = null; }
        this.add(data, button, Array.isArray(lines) && lines.length ? lines : null).finally(() => this.pendingForms.delete(form));
      }

      onClick(event) {
        if (event.target.closest('[data-cart-close]')) { this.close(); return; }
        if (this.pending && event.target.closest('.ecp-content a')) { event.preventDefault(); return; }
        const button = event.target.closest('[data-cart-step], [data-cart-remove]');
        if (!button || button.disabled || this.pending) return;
        const item = button.closest('[data-cart-item]');
        const input = item.querySelector('[data-cart-quantity]');
        if (button.hasAttribute('data-cart-remove')) {
          this.change(item.dataset.key, 0, button);
          return;
        }
        if (button.dataset.cartStep === '1' && this.atLimit(input)) {
          this.stockFeedback(input.closest('.ecp-quantity'), button.dataset.limitLabel, event.detail === 0);
          return;
        }
        this.change(item.dataset.key, this.steppedQuantity(input, Number(button.dataset.cartStep)), button);
      }

      onQuantityChange(event) {
        const input = event.target.closest('[data-cart-quantity]');
        if (!input || this.pending) return;
        if (!this.validChangeInput(input)) {
          this.stockFeedback(input.closest('.ecp-quantity'), this.inputLimitLabel(input));
          input.value = input.dataset.currentQuantity;
          this.syncCartLimits();
          return;
        }
        if (input.value === input.dataset.currentQuantity) return;
        this.change(input.closest('[data-cart-item]').dataset.key, Number(input.value), input);
      }

      remaining(variant, current = 0) {
        if (!variant.available) return 0;
        if (variant.limit < 0) return Infinity;
        const limit = Math.max(0, variant.limit - variant.inCart + current);
        return limit < variant.min ? 0 : variant.min + Math.floor((limit - variant.min) / variant.step) * variant.step;
      }

      quantityError(variant, quantity, current = 0) {
        if (current && quantity === 0) return '';
        if (!Number.isSafeInteger(quantity) || quantity < variant.min || (quantity - variant.min) % variant.step !== 0) {
          return !Number.isSafeInteger(quantity) || quantity < variant.min ? this.dataset.minimum.replace('__quantity__', variant.min) : this.dataset.rule.replace('__increment__', variant.step);
        }
        if (current && quantity < current) return '';
        const max = this.remaining(variant, current);
        if (quantity <= max) return '';
        if (current) return max ? this.dataset.limit.replace('__quantity__', max) : this.dataset.unavailable;
        if (!variant.available || variant.limit === 0) return this.dataset.notAvailable;
        return max ? this.dataset.addLimit.replace('__requested__', quantity).replace('__quantity__', max) : this.dataset.noneRemaining;
      }

      atLimit(input) {
        return input.disabled || input.max !== '' && Number(input.value) + Number(input.step || 1) > Number(input.max);
      }

      inputLimitLabel(input) {
        const quantity = Number(input.value), min = Number(input.min) || 1, step = Number(input.step) || 1;
        if (!Number.isSafeInteger(quantity) || quantity < min) return this.dataset.minimum.replace('__quantity__', min);
        if ((quantity - min) % step !== 0) return this.dataset.rule.replace('__increment__', step);
        return Number(input.max) === 0 ? this.dataset.notAvailable : this.dataset.limit.replace('__quantity__', input.max);
      }

      setPlusState(button, atLimit) {
        if (!button.dataset.increaseLabel) button.dataset.increaseLabel = button.getAttribute('aria-label') || '';
        const label = this.dataset.noneRemaining;
        button.dataset.atLimit = String(atLimit);
        button.dataset.limitLabel = label;
        button.setAttribute('aria-disabled', String(atLimit));
        button.setAttribute('aria-label', atLimit ? `${button.dataset.increaseLabel}: ${label}` : button.dataset.increaseLabel);
      }

      stockFeedback(element, label, keyboard = false) {
        const announcement = this.querySelector('[data-stock-announcement]');
        if (announcement) announcement.textContent = label || this.dataset.notAvailable;
        if (!element || keyboard || element.classList.contains('ecp-stock-feedback')) return;
        element.classList.add('ecp-stock-feedback');
        setTimeout(() => element.classList.remove('ecp-stock-feedback'), 280);
      }

      normalizeProductQuantity(input) {
        if (!input || input.disabled) return;
        const min = Number(input.min) || 1, step = Number(input.step) || 1;
        const max = input.max === '' ? Infinity : Number(input.max);
        const value = Number(input.value);
        input.value = String(Math.min(max, Math.max(min, min + Math.round(((Number.isFinite(value) ? value : min) - min) / step) * step)));
        this.syncProducts();
      }

      steppedQuantity(input, direction) {
        const min = Number(input.min) || 1, step = Number(input.step) || 1;
        const current = Number(input.dataset.currentQuantity || input.value) || min;
        const max = input.max === '' ? Infinity : Number(input.max);
        if (direction < 0) {
          const lower = min + Math.floor((current - min - 1) / step) * step;
          return Math.max(min, max >= min ? Math.min(lower, min + Math.floor((max - min) / step) * step) : lower);
        }
        return Math.min(max, current + step);
      }

      validChangeInput(input) {
        const value = Number(input.value), current = Number(input.dataset.currentQuantity);
        return input.value.trim() !== '' && Number.isSafeInteger(value) && (value === 0 || value >= Number(input.min) && (value - Number(input.min)) % Number(input.step || 1) === 0 && (value < current || input.checkValidity()));
      }

      onStockInput(event) {
        const input = event.target;
        if (input.matches('[data-cartitem] [data-quantity-input]')) {
          event.stopImmediatePropagation();
          this.syncCartLimits();
          this.syncCheckout();
          if (event.type === 'change') this.commitPageQuantity(input);
          return;
        }
        if (input.matches('[data-cart-quantity]')) return;
        const detailOverflow = input.form?.closest('excel-product-detail') && input.max !== '' && Number(input.value) > Number(input.max);
        if ((event.type === 'change' || event.type === 'focusout' || detailOverflow) && input.name === 'quantity' && input.form?.closest('excel-product-card, excel-product-detail')) {
          const previous = input.value;
          const label = this.inputLimitLabel(input);
          this.normalizeProductQuantity(input);
          if (previous !== input.value) this.stockFeedback(input.closest('[data-quantity-selector]'), label);
        }
        this.syncProducts();
        if (event.type === 'change') queueMicrotask(() => this.syncProducts());
      }

      commitPageQuantity(input) {
        if (this.pending) return;
        if (!this.validChangeInput(input)) {
          this.stockFeedback(input.closest('[data-quantity-selector]'), this.inputLimitLabel(input));
          input.value = input.dataset.currentQuantity;
          this.syncCartLimits();
          return;
        }
        if (input.value !== input.dataset.currentQuantity) this.change(input.closest('[data-cartitem]').dataset.cartitemKey, Number(input.value), input, true);
      }

      updateStock(stock) {
        this.stock = stock;
        this.syncProducts();
        this.syncCartLimits();
      }

      async readStock(productUrl = this.dataset.cartUrl, variantId) {
        const url = new URL(productUrl, location.origin);
        if (url.origin !== location.origin) throw new Error(this.dataset.error);
        url.searchParams.set('section_id', 'excel-cart-availability');
        if (variantId) url.searchParams.set('variant', variantId);
        const response = await fetch(url, {credentials:'same-origin', cache:'no-store'});
        if (!response.ok) throw new Error(this.dataset.error);
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const data = parsed.querySelector('[data-cart-stock]');
        if (!data) throw new Error(this.dataset.error);
        const stock = JSON.parse(data.textContent);
        if (variantId && String(stock.variant?.id) !== String(variantId)) throw new Error(this.dataset.error);
        return stock;
      }

      async loadProduct(marker) {
        const form = marker.closest('form'), id = form.elements.namedItem('id')?.value;
        if (!id || marker.dataset.loadingVariant === id) return;
        marker.dataset.loadingVariant = id;
        try {
          const stock = await this.readStock(marker.dataset.productUrl, id);
          if (form.elements.namedItem('id')?.value !== id || !marker.isConnected) return;
          this.productStock.set(marker, stock.variant);
          this.updateStock(stock);
        } catch (error) {
          const message = form.querySelector('[data-stock-message]');
          if (message) { message.hidden = false; message.textContent = error.message; }
        } finally { delete marker.dataset.loadingVariant; }
      }

      refreshProducts() {
        document.querySelectorAll('[data-stock-product]').forEach(marker => this.loadProduct(marker));
        if (document.querySelector('[data-cartitem]')) this.readStock().then(stock => this.updateStock(stock)).catch(() => {});
      }

      syncProducts() {
        document.querySelectorAll('[data-quick-buy][data-stock-variant]').forEach(button => {
          const original = this.productStock.get(button) || JSON.parse(button.dataset.stockVariant);
          const variant = this.stock.items.find(item => String(item.variant.id) === String(original.id))?.variant || original;
          const inCart = this.stock.items.filter(item => String(item.variant.id) === String(original.id)).reduce((sum, item) => sum + item.quantity, 0);
          this.productStock.set(button, variant);
          button.dataset.stockMinimum = variant.min;
          button.disabled = this.remaining({...variant, inCart}) < variant.min || button.getAttribute('aria-busy') === 'true';
        });
        document.querySelectorAll('[data-stock-product]').forEach(marker => {
          const form = marker.closest('form');
          if (!form) return;
          if (!this.productStock.has(marker)) this.productStock.set(marker, JSON.parse(marker.textContent));
          let variant = this.productStock.get(marker);
          const id = form.elements.namedItem('id')?.value;
          const buttons = [...form.querySelectorAll('[type="submit"]')].filter(button => button.name !== 'checkout');
          if (String(variant.id) !== String(id)) {
            buttons.forEach(button => { button.disabled = true; });
            form.querySelectorAll('[data-availability-call]').forEach(call => { call.hidden = true; });
            this.loadProduct(marker);
            return;
          }
          const live = this.stock.items.find(item => String(item.variant.id) === String(id))?.variant;
          variant = {...variant, ...live, inCart:this.stock.items.filter(item => String(item.variant.id) === String(id)).reduce((sum,item) => sum + item.quantity, 0)};
          this.productStock.set(marker, variant);
          const input = form.elements.namedItem('quantity');
          const max = this.remaining(variant);
          const callForAvailability = max < variant.min;
          form.querySelectorAll('[data-availability-call]').forEach(call => { call.hidden = !callForAvailability; });
          form.querySelectorAll('[data-availability-action]').forEach(button => { button.hidden = callForAvailability; });
          const quantity = Number(input?.value ?? variant.min);
          const essentials = form.closest('excel-product-card');
          const detail = form.closest('excel-product-detail');
          if (essentials || detail) form.noValidate = true;
          if (input) {
            input.min = variant.min; input.step = variant.step;
            input.max = Number.isFinite(max) ? max : '';
            input.disabled = max < variant.min;
            const selector = input.closest('[data-quantity-selector]');
            selector?.querySelectorAll('[data-quantity-plus], [data-quantity-minus]').forEach(button => {
              const atLimit = input.disabled || (button.hasAttribute('data-quantity-plus') ? quantity + variant.step > max : quantity <= variant.min);
              if ((essentials || detail) && button.hasAttribute('data-quantity-plus')) {
                button.disabled = Boolean(detail && input.disabled);
                this.setPlusState(button, atLimit);
              } else button.disabled = atLimit;
              button.closest('[data-button-wrapper]')?.classList.toggle('quantity-selector__button-wrapper--disabled', button.disabled);
            });
          }
          const error = this.quantityError(variant, quantity);
          buttons.forEach(button => { button.disabled = (detail ? callForAvailability : !essentials && Boolean(error)) || button.getAttribute('aria-busy') === 'true'; });
          buttons.forEach(button => {
            const label = button.querySelector('[data-essentials-action-label]');
            if (!label) return;
            const state = max < variant.min ? 'sold-out' : error ? 'limit' : 'available';
            const specialOrder = variant.tracked && variant.inventoryPolicy === 'continue' && variant.inCart + quantity > variant.inventoryQuantity;
            button.dataset.stockState = state;
            button.classList.toggle('is-special-order', specialOrder && state !== 'sold-out');
            button.setAttribute('aria-disabled', String(Boolean(error)));
            label.textContent = state === 'sold-out' ? button.dataset.stockSoldOutLabel : specialOrder ? button.dataset.stockSpecialOrderLabel : button.dataset.stockAvailableLabel;
          });
          form.querySelectorAll('.shopify-payment-button').forEach(element => { element.inert = Boolean(error); });
          const message = form.querySelector('[data-stock-message]');
          if (message) { message.hidden = Boolean(essentials) || callForAvailability || !error; message.textContent = essentials || callForAvailability ? '' : error; }
          const delivery = form.closest('excel-product-detail')?.querySelector('excel-delivery-options');
          if (delivery && (delivery.dataset.inCart !== String(variant.inCart) || delivery.dataset.stockLimit !== String(variant.limit) || delivery.dataset.available !== String(variant.available))) {
            delivery.dataset.inCart = variant.inCart; delivery.dataset.stockLimit = variant.limit; delivery.dataset.available = variant.available;
            delivery.dispatchEvent(new Event('excel:availability'));
          }
        });
        document.querySelectorAll('[data-essentials-variant][data-variant-stock]').forEach(option => {
          const form = option.closest('form');
          const essentials = form?.closest('excel-product-card');
          if (!essentials) return;
          const original = JSON.parse(option.dataset.variantStock);
          const selected = this.productStock.get(form.querySelector('[data-stock-product]'));
          const current = String(selected?.id) === String(original.id) ? selected : original;
          const matching = this.stock.items.filter(item => String(item.variant.id) === String(original.id));
          const variant = {...current, ...(matching[0]?.variant || {}), inCart:matching.reduce((sum, item) => sum + item.quantity, 0)};
          const remaining = this.remaining(variant);
          const unavailable = remaining < variant.min;
          option.setAttribute('aria-disabled', String(unavailable));
          option.dataset.stockState = unavailable ? 'sold-out' : 'available';
          const note = option.querySelector('[data-essentials-option-note]');
          if (note) note.textContent = !variant.available || variant.limit === 0 ? essentials.dataset.outOfStock : '';
        });
      }

      syncCartLimits() {
        this.invalidCart = false;
        document.querySelectorAll('[data-cart-item], [data-cartitem]').forEach(row => {
          const line = this.stock.items.find(item => item.key === (row.dataset.key || row.dataset.cartitemKey));
          if (!line) return;
          const input = row.querySelector('[data-cart-quantity], [data-quantity-input]');
          if (!input) return;
          const max = this.remaining(line.variant, line.quantity);
          input.min = line.variant.min; input.step = line.variant.step; input.max = Number.isFinite(max) ? max : '';
          const error = this.quantityError(line.variant, line.quantity, line.quantity);
          this.invalidCart ||= Boolean(error);
          const message = row.querySelector('[data-line-stock-message]');
          if (message) { message.hidden = true; message.textContent = ''; }
          input.setAttribute('aria-invalid', String(Boolean(error)));
          row.querySelectorAll('[data-cart-step], [data-quantity-plus], [data-quantity-minus]').forEach(button => {
            const plus = button.dataset.cartStep === '1' || button.hasAttribute('data-quantity-plus');
            const disabled = !plus && line.quantity <= line.variant.min;
            if (plus) this.setPlusState(button, Number(input.value) + line.variant.step > max);
            if (this.pending) button.dataset.wasDisabled = String(disabled);
            button.disabled = Boolean(this.pending) || disabled;
            button.closest('[data-button-wrapper]')?.classList.toggle('quantity-selector__button-wrapper--disabled', button.disabled);
          });
        });
        this.syncCheckout();
      }

      // Wire and cable lines without a trade account (marked by snippets/cart-item.liquid) hold checkout until they're removed.
      wireHold() {
        return Boolean(document.querySelector('[data-cartitem][data-wire-trade-only]'));
      }

      syncCheckout() {
        this.cartDirty = [...document.querySelectorAll('[data-cartitem] [data-quantity-input]')].some(input => input.value !== input.dataset.currentQuantity);
        const wireHold = this.wireHold();
        const disabled = Boolean(this.pending) || this.invalidCart || this.cartDirty || wireHold;
        document.querySelectorAll('form[action$="/cart"] [name="checkout"]').forEach(button => { button.disabled = disabled; });
        document.querySelectorAll('.additional-checkout-buttons').forEach(element => { element.inert = disabled; element.hidden = wireHold; });
        document.querySelectorAll('[data-wire-hold-note]').forEach(note => { note.hidden = !wireHold; });
      }

      async validateAdd(data, button) {
        const marker = button?.form?.querySelector('[data-stock-product]');
        const productUrl = marker?.dataset.productUrl || button?.dataset.productUrl;
        if (!productUrl) throw new Error(this.dataset.error);
        const stock = await this.readStock(productUrl, data.get('id'));
        if (marker) this.productStock.set(marker, stock.variant);
        else if (button) this.productStock.set(button, stock.variant);
        this.updateStock(stock);
        const error = this.quantityError(stock.variant, Number(data.get('quantity') || stock.variant.min));
        if (error) throw Object.assign(new Error(error), {stockLimit:true});
      }

      async validateChange(key, quantity) {
        if (quantity === 0) return;
        const stock = await this.readStock();
        this.updateStock(stock);
        const line = stock.items.find(item => item.key === key);
        if (!line) throw new Error(this.dataset.error);
        const error = this.quantityError(line.variant, quantity, line.quantity);
        if (error) throw Object.assign(new Error(error), {stockLimit:true});
      }

      onKeydown(event) {
        if (event.key === 'Enter' && event.target.matches('[data-cart-quantity]')) {
          event.preventDefault();
          this.onQuantityChange(event);
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = Array.from(this.dialog.querySelectorAll('a[href]:not([tabindex="-1"]), button:not(:disabled), input:not(:disabled)')).filter(element => element.getClientRects().length && element.getAttribute('aria-disabled') !== 'true');
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === this.heading)) {
          event.preventDefault(); last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first?.focus();
        }
      }

      show(trigger, keyboard = false) {
        if (this.dialog.open) return;
        this.hideToast(true);
        this.returnFocus = trigger || document.activeElement;
        document.dispatchEvent(new Event('closeFlyouts'));
        this.openSequence = (this.openSequence || 0) + 1;
        this.savedScroll = {left:window.scrollX, top:window.scrollY, behavior:'instant'};
        this.dialog.toggleAttribute('data-keyboard', keyboard);
        this.locked = true;
        document.documentElement.classList.add('ecp-open');
        this.dialog.showModal();
        this.heading.focus({preventScroll:true});
        window.scrollTo(this.savedScroll);
      }

      open(trigger, keyboard = false) {
        this.show(trigger, keyboard);
        this.querySelector('[data-cart-added]').hidden = true;
        return this.enqueue(async () => {
          try { await this.refresh(); } catch { this.showError(this.dataset.error); }
        });
      }

      close(restoreFocus = true) {
        if (!this.dialog.open) return;
        this.dialog.close();
        this.afterClose(restoreFocus);
      }

      afterClose(restoreFocus = true) {
        if (!this.locked || this.dialog.open) return;
        this.locked = false;
        document.documentElement.classList.remove('ecp-open');
        if (this.savedScroll) window.scrollTo(this.savedScroll);
        if (restoreFocus && this.returnFocus?.isConnected) this.returnFocus.focus({preventScroll:true});
        if (restoreFocus && this.cartPageChanged && !this.pending) location.reload();
      }

      enqueue(operation) {
        this.pending += 1;
        this.setBusy(true);
        const next = this.queue.then(async () => {
          this.clearError();
          try { return await operation(); }
          finally {
            this.pending -= 1;
            if (!this.pending) {
              this.setBusy(false);
              if (this.cartPageChanged && !this.dialog.open) location.reload();
            }
          }
        });
        this.queue = next.catch(() => {});
        return next;
      }

      setBusy(busy) {
        this.dialog.setAttribute('aria-busy', String(busy));
        this.querySelector('[data-cart-feedback]').textContent = busy ? this.dataset.loading : this.querySelector('[data-cart-error]').hidden ? this.dataset.updated : '';
        document.querySelectorAll('excel-cart-popup .ecp-content button:not([data-cart-close]), excel-cart-popup .ecp-content input, [data-cartitem] button, [data-cartitem] input').forEach(control => {
          if (busy) {
            if (!control.hasAttribute('data-was-disabled')) control.dataset.wasDisabled = String(control.disabled);
            control.disabled = true;
          } else if (control.hasAttribute('data-was-disabled')) {
            control.disabled = control.dataset.wasDisabled === 'true';
            delete control.dataset.wasDisabled;
          }
        });
        this.querySelectorAll('.ecp-content a').forEach(link => {
          if (busy) link.setAttribute('aria-disabled', 'true'); else link.removeAttribute('aria-disabled');
        });
        this.syncCartLimits();
      }

      clearError() {
        const error = this.querySelector('[data-cart-error]');
        error.hidden = true;
        error.textContent = '';
        this.querySelector('[data-cart-recovery]').hidden = true;
      }

      showError(message) {
        const error = this.querySelector('[data-cart-error]');
        error.textContent = message || this.dataset.error;
        error.hidden = false;
        this.querySelector('[data-cart-recovery]').hidden = false;
      }

      async request(url, options = {}) {
        let response;
        try { response = await fetch(url, {credentials:'same-origin', ...options}); }
        catch { throw new Error(this.dataset.error); }
        let data;
        try { data = await response.json(); } catch { throw new Error(this.dataset.error); }
        if (!response.ok || data.status >= 400) {
          throw Object.assign(new Error(typeof data.description === 'string' ? data.description : (typeof data.message === 'string' ? data.message : this.dataset.error)), {status:response.status || data.status});
        }
        return data;
      }

      async refresh(html) {
        if (!html) {
          const url = new URL(this.dataset.cartUrl, location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, {credentials:'same-origin', cache:'no-store'});
          if (!response.ok) throw new Error(this.dataset.error);
          html = await response.text();
        }
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const content = parsed.querySelector('[data-cart-content]');
        const stockData = content?.querySelector('[data-cart-stock]');
        if (!stockData) throw new Error(this.dataset.error);
        const stock = JSON.parse(stockData.textContent);
        const previous = this.querySelector('[data-cart-content]');
        const scrollTop = previous.scrollTop;
        const listScrollTop = previous.querySelector('.ecp-items')?.scrollTop || 0;
        previous.replaceWith(content);
        content.scrollTop = scrollTop;
        const list = content.querySelector('.ecp-items');
        if (list) list.scrollTop = listScrollTop;
        this.updateStock(stock);
        this.setBusy(this.pending > 0);
        const count = Number(content.dataset.itemCount);
        document.querySelectorAll('[data-header-cart-count]').forEach(badge => {
          badge.dataset.headerCartCount = count || '';
          badge.classList.toggle('visible', count > 0);
        });
        window.dispatchEvent(new CustomEvent('cartcount:update', {detail:{item_count:count}}));
      }

      add(data, button, lines = null) {
        const wasDisabled = button?.disabled;
        if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
        this.querySelector('[data-cart-added]').hidden = true;
        data.set('sections', this.dataset.sectionId);
        data.set('sections_url', this.dataset.cartUrl);
        return this.enqueue(async () => {
          let added = false, summary = null;
          try {
            await this.validateAdd(data, button);
            const result = lines
              ? await this.request(`${this.dataset.addUrl}.js`, {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({items:lines, sections:data.get('sections'), sections_url:data.get('sections_url')})})
              : await this.request(`${this.dataset.addUrl}.js`, {method:'POST', body:data});
            added = true;
            summary = this.addedSummary(data, lines, result);
            this.cartPageChanged = document.body.classList.contains('template-cart');
            await this.refresh(result.sections?.[this.dataset.sectionId]);
            this.showToast(summary);
          } catch (error) {
            if (!added) { try { await this.refresh(); } catch {} }
            let stockError = error.stockLimit ? error.message : '';
            if (!added && error.status === 422) {
              try { await this.validateAdd(data, button); } catch (latest) { if (latest.stockLimit) stockError = latest.message; }
            }
            if (stockError) {
              this.normalizeProductQuantity(button?.form?.elements.namedItem('quantity'));
              this.stockFeedback(button, stockError);
              if (this.dialog.open) this.close();
            } else if (added) {
              // The item is in the cart even though the preview failed; the toast opens a fresh cart.
              this.showToast(summary);
            } else {
              this.show(button);
              this.showError(error.message);
            }
          } finally {
            if (button) { button.disabled = wasDisabled; button.removeAttribute('aria-busy'); }
            this.syncProducts();
          }
        });
      }

      // Shopify confirms a whole add or rejects it, so the requested quantities are what was added.
      addedSummary(data, lines, result) {
        const quantities = lines ? lines.map(line => Number(line.quantity) || 0) : [Number(data.get('quantity')) || 1];
        const items = lines ? result?.items || [] : [result];
        const priced = items.length === quantities.length && items.every(item => Number.isFinite(item?.final_price));
        return {
          count:quantities.reduce((sum, quantity) => sum + quantity, 0),
          cents:priced ? items.reduce((sum, item, index) => sum + item.final_price * quantities[index], 0) : NaN,
          // Wire sold by the foot carries a cut length, so its quantity reads as feet.
          feet:lines ? lines.every(line => line.properties?.['Cut length']) : data.has('properties[Cut length]')
        };
      }

      money(cents) {
        try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:this.dataset.currency || 'USD'}).format(cents / 100); }
        catch { return `$${(cents / 100).toFixed(2)}`; }
      }

      cartAnchor() {
        return [...document.querySelectorAll('.site-header-cart--button')].find(link => {
          const rect = link.getBoundingClientRect();
          return rect.width && rect.height && rect.bottom > 0 && rect.top < window.innerHeight;
        });
      }

      showToast({count, cents, feet}) {
        const toast = this.querySelector('[data-cart-toast]');
        if (!toast) return;
        const template = feet ? this.dataset.toastFeet : count === 1 ? this.dataset.toastOne : this.dataset.toastMany;
        const label = template.replace('__quantity__', count.toLocaleString(document.documentElement.lang || undefined));
        const price = cents > 0 ? `+${this.money(cents)}` : '';
        toast.querySelector('[data-cart-toast-label]').textContent = label;
        toast.querySelector('[data-cart-toast-price]').textContent = price;
        const announcement = this.querySelector('[data-stock-announcement]');
        if (announcement) announcement.textContent = [this.dataset.toastAdded, label, price].filter(Boolean).join(', ');
        const visible = !toast.hidden && toast.dataset.state !== 'out';
        toast.hidden = false;
        toast.dataset.state = '';
        void toast.offsetWidth;
        toast.dataset.state = visible ? 'pulse' : 'in';
        this.trackToast(toast);
        this.scheduleToastHide();
        document.querySelectorAll('[data-header-cart-count].visible').forEach(badge => {
          badge.classList.remove('ecp-count-bump');
          void badge.offsetWidth;
          badge.classList.add('ecp-count-bump');
          setTimeout(() => badge.classList.remove('ecp-count-bump'), 400);
        });
      }

      scheduleToastHide(delay = 2400) {
        clearTimeout(this.toastTimer);
        this.toastTimer = setTimeout(() => this.hideToast(), delay);
      }

      hideToast(immediate = false) {
        const toast = this.querySelector('[data-cart-toast]');
        if (!toast || toast.hidden) return;
        clearTimeout(this.toastTimer);
        const finish = () => { toast.hidden = true; toast.removeAttribute('data-state'); cancelAnimationFrame(this.toastFrame); };
        if (immediate) { finish(); return; }
        toast.dataset.state = 'out';
        this.toastTimer = setTimeout(finish, 260);
      }

      // Follows the header cart while the toast shows, since the sticky header condenses on scroll.
      trackToast(toast) {
        cancelAnimationFrame(this.toastFrame);
        const place = () => {
          if (toast.hidden) return;
          const anchor = this.cartAnchor()?.getBoundingClientRect();
          toast.toggleAttribute('data-anchored', Boolean(anchor));
          if (anchor) {
            // The page reserves a scrollbar gutter, so the body width is the visible edge.
            const viewport = Math.min(document.documentElement.clientWidth, document.body.clientWidth || Infinity);
            const width = toast.offsetWidth, center = anchor.left + anchor.width / 2;
            const right = Math.min(viewport - 12, anchor.right + 12);
            const left = Math.round(Math.max(12, Math.min(center - width / 2, right - width)));
            toast.style.top = `${Math.round(anchor.bottom + 8)}px`;
            toast.style.left = `${left}px`;
            toast.style.setProperty('--ecp-caret', `${Math.round(Math.max(24, Math.min(center - left, width - 24)))}px`);
          } else {
            toast.style.removeProperty('top');
            toast.style.removeProperty('left');
          }
          this.toastFrame = requestAnimationFrame(place);
        };
        place();
      }

      async refreshPage(html, sectionId) {
        if (!html) {
          const url = new URL(this.dataset.cartUrl, location.origin);
          url.searchParams.set('section_id', sectionId);
          const response = await fetch(url, {credentials:'same-origin', cache:'no-store'});
          if (!response.ok) throw new Error(this.dataset.error);
          html = await response.text();
        }
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const list = parsed.querySelector('[data-cart-item-list]');
        if (!list) { location.reload(); return; }
        document.querySelector('[data-cart-item-list]').replaceChildren(...list.childNodes);
        ['[data-cart-total]', '[data-cart-discounts]', '[data-free-shipping-bar]', '[data-cart-count]'].forEach(selector => {
          const incoming = [...parsed.querySelectorAll(selector)];
          document.querySelectorAll(selector).forEach((element, index) => {
            const replacement = incoming[index] || incoming[0];
            if (replacement) element.innerHTML = replacement.innerHTML;
          });
        });
        this.setBusy(this.pending > 0);
      }

      change(key, quantity, trigger, page = false) {
        const openSequence = this.openSequence;
        const keyboard = trigger.matches?.(':focus-visible');
        this.querySelector('[data-cart-added]').hidden = true;
        const focusType = trigger.hasAttribute('data-cart-quantity') ? 'input' : trigger.hasAttribute('data-cart-remove') ? 'remove' : trigger.dataset.cartStep;
        const beforeIndex = Array.from(this.querySelectorAll('[data-cart-item]')).findIndex(item => item.dataset.key === key);
        const pageSection = page ? document.querySelector('[data-section-type="static-cart"]')?.dataset.sectionId : null;
        let pageError = '';
        let stockError = '';
        return this.enqueue(async () => {
          try {
            await this.validateChange(key, quantity);
            const result = await this.request(`${this.dataset.changeUrl}.js`, {
              method:'POST', headers:{'Content-Type':'application/json'},
              body:JSON.stringify({id:key, quantity, sections:[this.dataset.sectionId, ...(pageSection ? [pageSection] : [])], sections_url:this.dataset.cartUrl})
            });
            this.cartPageChanged = !page && document.body.classList.contains('template-cart');
            await this.refresh(result.sections?.[this.dataset.sectionId]);
            if (pageSection) await this.refreshPage(result.sections?.[pageSection], pageSection);
            this.querySelector('[data-cart-added]').hidden = true;
          } catch (error) {
            try { await this.refresh(); } catch {}
            stockError = error.stockLimit ? error.message : '';
            if (error.status === 422) {
              try { await this.validateChange(key, quantity); } catch (latest) { if (latest.stockLimit) stockError = latest.message; }
            }
            if (pageSection) {
              try { await this.refreshPage(null, pageSection); } catch {}
              if (!stockError) pageError = error.message;
            } else if (!stockError) this.showError(error.message);
          }
        }).then(() => {
          if (page) {
            const row = [...document.querySelectorAll('[data-cartitem]')].find(item => item.dataset.cartitemKey === key);
            const message = row?.querySelector('[data-line-stock-message]');
            if (message && pageError) { message.textContent = pageError; message.hidden = false; }
            if (stockError) this.stockFeedback(row?.querySelector('[data-quantity-selector]'), stockError, keyboard);
            const pageFocus = trigger.hasAttribute('data-quantity-input') ? '[data-quantity-input]' : trigger.hasAttribute('data-quantity-plus') ? '[data-quantity-plus]' : '[data-quantity-minus]';
            row?.querySelector(pageFocus)?.focus({preventScroll:true});
            return;
          }
          if (!this.dialog.open || this.pending || this.openSequence !== openSequence) return;
          if (document.activeElement !== document.body && document.activeElement !== this.dialog && this.dialog.contains(document.activeElement)) return;
          const items = Array.from(this.querySelectorAll('[data-cart-item]'));
          const item = items.find(row => row.dataset.key === key) || items[Math.min(beforeIndex, items.length - 1)];
          if (stockError) this.stockFeedback(item?.querySelector('.ecp-quantity'), stockError, keyboard);
          const selector = focusType === 'input' ? '[data-cart-quantity]' : focusType === 'remove' ? '[data-cart-remove]' : `[data-cart-step="${focusType}"]:not(:disabled)`;
          const target = item?.querySelector(selector) || (keyboard ? item?.querySelector('[data-cart-quantity]') : this.heading) || this.querySelector('.ecp-checkout, .ecp-continue');
          target.focus({preventScroll:true});
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["excel-product-detail"]) return;
  try {
    
  if (!customElements.get('excel-product-detail')) {
    customElements.define('excel-product-detail', class extends HTMLElement {
      connectedCallback() {
        this.observeSpecLayout();
        this.startSupportStatus();
        if (this.initialized) return;
        this.initialized = true;
        const root = this;
        root.classList.add('exd-enhanced');
        const moreMedia = root.querySelector('[data-more-media]');
        if (moreMedia) {
          moreMedia.hidden = false;
          const originalMoreLabel = moreMedia.querySelector('span').textContent;
          moreMedia.addEventListener('click',()=>{
            const expanded = moreMedia.getAttribute('aria-expanded') !== 'true';
            moreMedia.setAttribute('aria-expanded',String(expanded));
            moreMedia.querySelector('span').textContent = expanded ? moreMedia.dataset.collapseLabel : originalMoreLabel;
            root.querySelector('.exd-thumbnails').classList.toggle('is-expanded',expanded);
          });
        }
        const medias = [...root.querySelectorAll('[data-media]')];
        let currentMedia = Math.max(0, medias.findIndex(media => media.dataset.media === root.dataset.initialMedia));
        const showMedia = index => {
          if (!medias.length) return;
          currentMedia = (index + medias.length) % medias.length;
          medias.forEach((media, i) => {
            media.hidden = i !== currentMedia;
            if (i !== currentMedia) {
              media.querySelectorAll('video').forEach(video => video.pause());
              media.querySelectorAll('iframe').forEach(frame => { if (!media.hiddenBefore) frame.src = frame.src; });
            }
            media.hiddenBefore = media.hidden;
          });
          root.querySelectorAll('[data-media-select]').forEach(thumb => {
            const active = thumb.dataset.mediaSelect === medias[currentMedia].dataset.media;
            if (active) thumb.setAttribute('aria-current','true'); else thumb.removeAttribute('aria-current');
          });
          if (currentMedia >= 5 && moreMedia) {
            root.querySelector('.exd-thumbnails').classList.add('is-expanded');
            moreMedia.setAttribute('aria-expanded','true');
            moreMedia.querySelector('span').textContent = moreMedia.dataset.collapseLabel;
          }
          root.querySelector('[data-gallery-count]').textContent = `${currentMedia + 1} / ${medias.length}`;
        };
        root.querySelectorAll('[data-media-select]').forEach(thumb => thumb.addEventListener('click', event => {
          event.preventDefault(); showMedia(medias.findIndex(media => media.dataset.media === thumb.dataset.mediaSelect));
        }));
        root.querySelectorAll('[data-media-step]').forEach(button => button.addEventListener('click', () => showMedia(currentMedia + Number(button.dataset.mediaStep))));
        const controls = root.querySelector('.exd-gallery-controls');
        if (controls) controls.hidden = false;
        showMedia(currentMedia);
        const stage = root.querySelector('.exd-stage');
        let touchStart;
        let suppressZoomUntil = 0;
        stage?.addEventListener('touchstart', event => { if (event.touches.length === 1) touchStart = [event.touches[0].clientX,event.touches[0].clientY]; }, {passive:true});
        stage?.addEventListener('touchend', event => {
          if (!touchStart || event.target.closest('video,iframe,model-viewer')) return;
          const dx = event.changedTouches[0].clientX-touchStart[0], dy = event.changedTouches[0].clientY-touchStart[1];
          if (Math.abs(dx)>55 && Math.abs(dx)>Math.abs(dy)*1.5) { showMedia(currentMedia + (dx<0 ? 1 : -1)); suppressZoomUntil = Date.now()+400; }
          touchStart = null;
        }, {passive:true});
        const zoomDialog = root.querySelector('.exd-zoom-dialog');
        let zoomTrigger;
        root.querySelectorAll('[data-zoom]').forEach(link => link.addEventListener('click', event => {
          event.preventDefault(); if (Date.now()<suppressZoomUntil) return; zoomTrigger = link;
          const image = zoomDialog.querySelector('img'); image.src = link.href; image.alt = link.querySelector('img').alt;
          zoomDialog.showModal();
        }));
        root.querySelector('[data-close-zoom]').addEventListener('click', () => zoomDialog.close());
        zoomDialog.addEventListener('click', event => { if (event.target === zoomDialog) zoomDialog.close(); });
        zoomDialog.addEventListener('close', () => zoomTrigger?.focus());
        const tabs = [...root.querySelectorAll('[data-tab]')];
        const tabList = root.querySelector('.exd-tabs'); tabList.setAttribute('role','tablist');
        const selectTab = selected => {
          tabs.forEach(tab => { const active = tab === selected; tab.setAttribute('aria-selected',String(active)); tab.tabIndex = active ? 0 : -1; });
          root.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== selected.dataset.tab; });
        };
        tabs.forEach((tab,index) => {
          tab.id = `${root.id}-tab-${index}`; tab.setAttribute('role','tab'); tab.setAttribute('aria-controls',tab.hash.slice(1));
          const panel = root.querySelector(tab.hash); panel.setAttribute('role','tabpanel'); panel.setAttribute('aria-labelledby',tab.id); panel.tabIndex=0;
          tab.addEventListener('click', event => { event.preventDefault(); selectTab(tab); });
          tab.addEventListener('keydown', event => {
            let next = index;
            if (event.key==='ArrowRight') next=(index+1)%tabs.length; else if (event.key==='ArrowLeft') next=(index+tabs.length-1)%tabs.length; else if (event.key==='Home') next=0; else if (event.key==='End') next=tabs.length-1; else return;
            event.preventDefault(); selectTab(tabs[next]); tabs[next].focus();
          });
        });
        selectTab(tabs.find(tab=>tab.hash===location.hash) || tabs[0]);
        const quantity = root.querySelector('.exd-quantity input');
        if (quantity && !root.querySelector('excel-wire-order')) {
        const syncQuantity = () => {
          const tiers = [...root.querySelectorAll('[data-price-tier]')];
          const tier = tiers.filter(row => Number(row.dataset.priceTier) <= Number(quantity.value)).at(-1) || tiers[0];
          const priceLabel = root.querySelector('[data-price-label]');
          if (tier && priceLabel && priceLabel.textContent !== tier.dataset.priceDisplay) {
            const display = tier.dataset.priceDisplay;
            priceLabel.textContent = display;
            // Redraw the raised symbol and cents, e.g. "$1,234.56" -> $ 1,234 56.
            const figure = root.querySelector('[data-price-figure]');
            const parts = display.match(/^([^\d]*)([\d,]+)(?:\.(\d+))?/);
            const raised = text => Object.assign(document.createElement('sup'), {textContent: text});
            if (parts) figure.replaceChildren(raised(parts[1].trim()), parts[2], ...(parts[3] ? [raised(parts[3])] : []));
            else figure.textContent = display;
          }
          tiers.forEach(row => row.classList.toggle('exd-tier-active', row === tier));
          root.querySelector('[data-quantity-step="-1"]').disabled = quantity.disabled || Number(quantity.value) <= Number(quantity.min);
          root.querySelector('[data-quantity-step="1"]').disabled = quantity.disabled;
          root.querySelectorAll('[data-quantity-step]').forEach(button => {
            button.closest('[data-button-wrapper]').classList.toggle('quantity-selector__button-wrapper--disabled', button.disabled);
          });
        };
        root.querySelectorAll('[data-quantity-step]').forEach(button=>button.addEventListener('click',()=>{
          if (quantity.disabled || button.disabled) return;
          if (!Number.isFinite(quantity.valueAsNumber)) quantity.value = quantity.min;
          if (Number(button.dataset.quantityStep) > 0) quantity.stepUp(); else quantity.stepDown();
          quantity.dispatchEvent(new Event('change',{bubbles:true}));
        }));
        quantity.addEventListener('input',syncQuantity); quantity.addEventListener('change',syncQuantity); syncQuantity();
        }
        const storeDialog = root.querySelector('[data-store-dialog]');
        if (storeDialog) {
          let storeTrigger;
          root.querySelectorAll('[data-store-open]').forEach(link => link.addEventListener('click', event => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;
            event.preventDefault();
            storeTrigger = link;
            storeDialog.querySelectorAll('[data-store-card]').forEach(card => {
              const row = root.querySelector(`[data-store-row="${card.dataset.storeCard}"]`);
              const status = card.querySelector('[data-store-status]');
              if (row && status) {
                status.classList.remove('is-available','is-special-order','is-unavailable');
                status.classList.add(['is-available','is-special-order'].find(name => row.classList.contains(name)) || 'is-unavailable');
                status.querySelector('[data-store-status-text]').textContent = row.querySelector('[data-pickup-status]').textContent;
              }
              card.classList.toggle('is-selected', card.dataset.storeCard === link.dataset.storeOpen);
            });
            storeDialog.showModal();
            storeDialog.querySelector('.exd-store-cards').scrollTop = 0;
          }));
          storeDialog.querySelector('[data-store-close]').addEventListener('click', () => storeDialog.close());
          storeDialog.addEventListener('click', event => { if (event.target === storeDialog) storeDialog.close(); });
          storeDialog.addEventListener('close', () => storeTrigger?.focus({preventScroll:true}));
        }
        root.querySelector('[data-variant-select]')?.addEventListener('change', event=>event.target.form.requestSubmit());
        const variantApply = root.querySelector('[data-variant-apply]'); if (variantApply) variantApply.hidden=true;
      }
      startSupportStatus() {
        const support = this.querySelector('[data-support-status]');
        if (!support || this.supportTimer) return;
        const schedule = JSON.parse(support.dataset.schedule);
        const clock = new Intl.DateTimeFormat('en-US', {timeZone:'America/Detroit', weekday:'short', hour:'numeric', minute:'numeric', hourCycle:'h23'});
        const updateSupport = () => {
          const now = Object.fromEntries(clock.formatToParts(new Date()).map(part => [part.type, part.value]));
          const hours = schedule[['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].indexOf(now.weekday)];
          const minutes = Number(now.hour) * 60 + Number(now.minute);
          const open = Boolean(hours) && minutes >= hours[0] && minutes < hours[1];
          const label = open ? support.dataset.openLabel : support.dataset.closedLabel;
          support.classList.toggle('is-open', open);
          support.classList.toggle('is-closed', !open);
          support.querySelector('[data-support-status-text]').textContent = label;
          support.querySelector('.exd-help-icon').title = support.dataset.hours ? `${label} · ${support.dataset.hours}` : label;
        };
        updateSupport();
        this.supportTimer = setInterval(updateSupport, 60000);
      }
      observeSpecLayout() {
        if (this.specResizeObserver || !('ResizeObserver' in window)) return;
        const grids = [...this.querySelectorAll('.exd-spec-grid')];
        const layout = () => {
          this.specLayoutFrame = null;
          grids.forEach(grid => {
            if (!grid.offsetWidth) return;
            [...grid.children].forEach(group => {
              const height = group.getBoundingClientRect().height;
              if (height > 0) group.style.setProperty('--exd-spec-span', Math.ceil(height + 24));
            });
            grid.classList.add('exd-spec-grid--packed');
          });
        };
        this.specResizeObserver = new ResizeObserver(() => {
          if (this.specLayoutFrame == null) this.specLayoutFrame = requestAnimationFrame(layout);
        });
        grids.forEach(grid => [...grid.children].forEach(group => this.specResizeObserver.observe(group)));
      }
      disconnectedCallback() {
        clearInterval(this.supportTimer);
        this.supportTimer = null;
        this.specResizeObserver?.disconnect();
        this.specResizeObserver = null;
        cancelAnimationFrame(this.specLayoutFrame);
        this.specLayoutFrame = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["excel-project-essentials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('excel-project-essentials')) {
    customElements.define('excel-project-essentials', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          this.resizeObserver?.observe(this.track);
          return;
        }
        this.initialized = true;
        this.track = this.querySelector('.excel-essentials__track');
        if (!this.track) return;
        this.arrows = [...this.querySelectorAll('[data-direction]')];
        this.arrows.forEach(button => button.addEventListener('click', () => this.move(button.dataset.direction === 'next' ? 1 : -1)));
        this.resizeObserver = new ResizeObserver(() => this.updateArrows());
        this.resizeObserver.observe(this.track);
        this.updateArrows();
      }
      disconnectedCallback() { this.resizeObserver?.disconnect(); }
      updateArrows() {
        const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
        this.arrows.forEach(button => { button.hidden = !overflow; });
      }
      move(direction) {
        const card = this.track.querySelector('.excel-essentials__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 16;
        const step = card.getBoundingClientRect().width + gap;
        const max = this.track.scrollWidth - this.track.clientWidth;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        if (direction > 0 && this.track.scrollLeft >= max - 2) this.track.scrollTo({ left: 0, behavior });
        else if (direction < 0 && this.track.scrollLeft <= 2) this.track.scrollTo({ left: max, behavior });
        else this.track.scrollBy({ left: direction * step, behavior });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
